import React from 'react';
import { Box } from '../../../../../../../../CommonComponents/OPL/Box/Box';
import { Dot } from '../../../../../../../../CommonComponents/OPL/Dot/Dot';
import { Text } from '../../../../../../../../CommonComponents/OPL/Text/Text';
import { formatPercentage } from '../../../../../../../../CommonUtils/formatNumber';

interface TooltipProps {
  probabilityOfSuccess: number;
  probabilityOfFailure: number;
}

export const Tooltip: React.FC<TooltipProps> = ({ probabilityOfSuccess, probabilityOfFailure }) => {
  return (
    <Box width="270px">
      <Box display="flex" alignItems="center" mb="8">
        <Dot bg="blue.500" mr="8" />
        <Text fontSize="small" color="bg">
          Successful Trials:{' '}
          <strong>
            {formatPercentage(probabilityOfSuccess, { decimalPlaces: 0 })} fully funded
          </strong>
        </Text>
      </Box>
      <Box display="flex" alignItems="center">
        <Dot bg="purple.500" mr="8" />
        <Text fontSize="small" color="bg">
          Unsuccessful Trials:{' '}
          <strong>
            {formatPercentage(probabilityOfFailure, { decimalPlaces: 0 })} money ran out
          </strong>
        </Text>
      </Box>
    </Box>
  );
};
